import WorkOsIpcRouter, { type WorkOsIpcRouterType } from '@shared/ipc/routers/WorkOsIpc.router'

class WorkOsIpcRenderer extends WorkOsIpcRouter implements WorkOsIpcRouterType {
  async getAccessToken(): Promise<string> {
    return this.exec('getAccessToken')
  }

  async showSignIn(screenHint?: 'sign-in' | 'sign-up'): Promise<void> {
    return this.exec('showSignIn', screenHint)
  }
}

export default new WorkOsIpcRenderer()
